__turbopack_context__.v({
  "carFinanceWidget": "AdsPanel-module__dNj69a__carFinanceWidget",
  "panelAds": "AdsPanel-module__dNj69a__panelAds",
  "plpDmpuAd": "AdsPanel-module__dNj69a__plpDmpuAd",
  "plpDmpuAdContainer": "AdsPanel-module__dNj69a__plpDmpuAdContainer",
});
